import Quill from 'quill';

// Importar o BlockEmbed para criar o Spoiler
const BlockEmbed = Quill.import('blots/block/embed');
const Delta = Quill.import('delta');

// Criar um blot customizado para o Spoiler
class SpoilerBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.setAttribute('class', 'spoiler-block');
    node.setAttribute('open', 'open');

    let summaryText = 'Clique para expandir/recolher';
    let contentHTML = 'Digite o conteúdo aqui...';

    // Se value é um objeto, extrair título e conteúdo
    if (typeof value === 'object' && value !== null) {
      summaryText = value.title || summaryText;
      contentHTML = value.content || contentHTML;
    } else if (typeof value === 'string') {
      contentHTML = value;
    }

    // Criar o summary (cabeçalho do spoiler) - EDITÁVEL
    const summary = document.createElement('summary');
    summary.setAttribute('class', 'spoiler-header');
    summary.setAttribute('contenteditable', 'true');
    summary.innerHTML = '<span class="spoiler-title">' + summaryText + '</span>';

    // Criar o conteúdo do spoiler
    const content = document.createElement('div');
    content.setAttribute('class', 'spoiler-content');
    content.setAttribute('contenteditable', 'true');
    content.innerHTML = contentHTML;

    // Adicionar listener para Shift+Enter no conteúdo
    content.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.shiftKey) {
        e.preventDefault();
        e.stopPropagation();

        // Inserir um <br> na posição do cursor
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          range.deleteContents();

          const br = document.createElement('br');
          range.insertNode(br);

          // Mover o cursor após o <br>
          range.setStartAfter(br);
          range.setEndAfter(br);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    });

    node.appendChild(summary);
    node.appendChild(content);

    return node;
  }

  static value(node) {
    const summary = node.querySelector('.spoiler-header .spoiler-title');
    const content = node.querySelector('.spoiler-content');

    return {
      title: summary ? summary.textContent : 'Clique para expandir/recolher',
      content: content ? content.innerHTML : ''
    };
  }
}

SpoilerBlot.blotName = 'spoiler';
SpoilerBlot.tagName = 'details';

// Registrar o blot
Quill.register(SpoilerBlot);

// Handler para inserir imagem em Base64
const imageHandler = function() {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = async () => {
    const file = input.files[0];
    if (file) {
      // Validar tamanho (máximo 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Imagem muito grande! Tamanho máximo: 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result;
        const quill = this.quill;
        const range = quill.getSelection(true);
        quill.insertEmbed(range.index, 'image', base64);
        quill.setSelection(range.index + 1);
      };
      reader.readAsDataURL(file);
    }
  };
};

// Handler para inserir Spoiler
const spoilerHandler = function() {
  const quill = this.quill;
  const range = quill.getSelection(true);

  if (range) {
    // Inserir o spoiler
    quill.insertEmbed(range.index, 'spoiler', 'Digite o conteúdo aqui...', Quill.sources.USER);
    quill.setSelection(range.index + 1, Quill.sources.SILENT);
  }
};

// Configuração completa dos módulos do ReactQuill
export const quillModules = {
  toolbar: {
    container: [
      // Estilos de cabeçalho
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      // Tamanho da fonte
      [{ 'size': ['small', false, 'large', 'huge'] }],

      // Formatação
      ['bold', 'italic', 'underline', 'strike'],

      // Cores
      [{ 'color': [] }, { 'background': [] }],

      // Alinhamento
      [{ 'align': [] }],

      // Listas
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],

      // Outros
      ['blockquote', 'code-block'],

      // Link e Imagem
      ['link', 'image'],

      // Spoiler (bloco colapsável)
      ['spoiler'],

      // Limpar formatação
      ['clean']
    ],
    handlers: {
      image: imageHandler,
      spoiler: spoilerHandler
    }
  },
  clipboard: {
    matchVisual: false,
    matchers: [
      // Converter <details> do BD para o blot spoiler
      ['DETAILS', function(node, delta) {
        // Verificar se é um spoiler-block
        if (node.classList && node.classList.contains('spoiler-block')) {
          const summary = node.querySelector('.spoiler-header .spoiler-title');
          const content = node.querySelector('.spoiler-content');

          const summaryText = summary ? summary.textContent : 'Clique para expandir/recolher';
          const contentHTML = content ? content.innerHTML : '';

          // Retornar um delta que insere o spoiler com título e conteúdo
          return new Delta().insert({ spoiler: { title: summaryText, content: contentHTML } });
        }
        return delta;
      }]
    ]
  }
};

// Formatos permitidos
export const quillFormats = [
  'header',
  'size',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'align',
  'list', 'bullet', 'indent',
  'blockquote', 'code-block',
  'link', 'image',
  'spoiler'
];

// Ativar funcionalidade de spoilers em HTML renderizado (visualização)
export const activateSpoilers = () => {
  // Garantir que todos os spoilers tenham a estrutura correta
  const spoilers = document.querySelectorAll('details.spoiler-block');

  spoilers.forEach(spoiler => {
    // Se já foi ativado, pular
    if (spoiler.hasAttribute('data-spoiler-active')) return;

    spoiler.setAttribute('data-spoiler-active', 'true');

    // Garantir que tenha summary
    if (!spoiler.querySelector('summary')) {
      const summary = document.createElement('summary');
      summary.className = 'spoiler-header';
      summary.innerHTML = '<span class="spoiler-title">Clique para expandir/recolher</span>';
      spoiler.insertBefore(summary, spoiler.firstChild);
    }

    // Remover contentEditable de todos os elementos dentro do spoiler (visualização)
    // Isso garante que o conteúdo não seja editável fora do editor Quill
    const editableElements = spoiler.querySelectorAll('[contenteditable]');
    editableElements.forEach(el => {
      el.removeAttribute('contenteditable');
    });

    // Garantir que o conteúdo dentro do spoiler não seja editável
    const content = spoiler.querySelector('.spoiler-content');
    if (content) {
      content.setAttribute('contenteditable', 'false');
      // Remover de todos os filhos também
      const allChildren = content.querySelectorAll('*');
      allChildren.forEach(child => {
        child.setAttribute('contenteditable', 'false');
      });
    }
  });
};

// CSS para o Spoiler (injetar no documento)
export const injectSpoilerStyles = () => {
  if (document.getElementById('spoiler-styles')) return;

  const style = document.createElement('style');
  style.id = 'spoiler-styles';
  style.textContent = `
    /* Ícone do botão Spoiler na toolbar */
    .ql-spoiler::before {
      content: '▼';
      font-weight: bold;
      font-size: 14px;
    }

    .ql-toolbar button.ql-spoiler {
      width: auto !important;
      padding: 0 8px !important;
    }

    /* Estilos do bloco Spoiler usando <details> e <summary> */
    details.spoiler-block {
      border: 1px solid #ccc;
      border-radius: 4px;
      margin: 10px 0;
      background: #f9f9f9;
      padding: 10px;
    }

    details.spoiler-block summary.spoiler-header {
      padding: 10px;
      background: #e9e9e9;
      cursor: pointer;
      user-select: none;
      font-weight: bold;
      border-radius: 4px;
      margin: -10px -10px 10px -10px;
      list-style: none; /* Remove seta padrão */
    }

    details.spoiler-block summary.spoiler-header::-webkit-details-marker {
      display: none; /* Remove seta padrão no Chrome/Safari */
    }

    details.spoiler-block summary.spoiler-header::before {
      content: '▶ ';
      display: inline-block;
      transition: transform 0.2s;
    }

    details.spoiler-block[open] summary.spoiler-header::before {
      content: '▼ ';
    }

    details.spoiler-block summary.spoiler-header:hover {
      background: #ddd;
    }

    details.spoiler-block .spoiler-content {
      padding: 5px 0;
    }

    /* Garantir que conteúdo na visualização não pareça editável */
    details.spoiler-block .spoiler-content[contenteditable="false"] {
      cursor: default;
      user-select: text;
    }

    details.spoiler-block .spoiler-content[contenteditable="false"] * {
      cursor: default;
    }
  `;
  document.head.appendChild(style);
};
